import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from 'src/app/services/authorization.service';

@Component({
  selector: 'app-authorization-modal',
  templateUrl: './authorization-modal.component.html',
  styleUrls: ['./authorization-modal.component.scss']
})
export class AuthorizationModalComponent implements OnInit {

  public user: any;
  public status: boolean = true;

  constructor(private authorizationService: AuthorizationService) { }

  ngOnInit(): void {
    this.user = {
      username: '',
      password: ''
    };
  }

  login() {
    if (!this.user.username || !this.user.password) {
      alert('Не указан логин или пароль');
      return;
    }

    this.authorizationService.login(this.user).subscribe((response) => {
      this.status = Boolean(response);
      if (this.status) {
        window.location.href = '/private-office';
      }
    });
  }

}
